import React, { Component } from "react";
import classnames from "classnames";

import { defined } from "@formant/core/common/defined";
import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { SortOrder } from "@formant/core/model/SortOrder";

import { Breakpoint } from "../../../utils/breakpoint";
import { SortIcon } from "../SortIcon";
import * as styles from "./DataTableHeader.scss";

export interface IDataTableHeaderProps<T> {
    context: T;
    onClick?: (context: T) => void;
    sortActive?: boolean;
    sortOrder?: SortOrder;
    className?: string;
    hideBelow?: Breakpoint;
    children?: React.ReactNode;
}

export class DataTableHeader<T> extends Component<
    IDataTableHeaderProps<T> & ITestableComponentProps
> {
    public render() {
        const {
            onClick,
            sortActive,
            sortOrder,
            hideBelow,
            className,
            children,
        } = this.props;
        return (
            <th
                className={classnames(
                    styles["data-table-header"],
                    sortActive && styles.active,
                    onClick && styles.sortable,
                    hideBelow && styles[`hide-below-${hideBelow}`],
                    className,
                )}
                onClick={onClick && this.onClick}
                data-testid={this.props["data-testid"]}
            >
                <div className={styles.container}>
                    {children}
                    {onClick &&
                        sortActive !== undefined &&
                        sortOrder !== undefined && (
                            <SortIcon
                                active={sortActive}
                                order={sortOrder}
                                className={styles.sort}
                            />
                        )}
                </div>
            </th>
        );
    }

    private onClick = () => {
        const { onClick, context } = this.props;
        defined(onClick)(context);
    };
}
